<!--Display stars-->
<svg [ngClass]="{'star-rating-filled': rating>=starId, 'star-rating-blank': rating < starId}" (mouseenter)="onStarEnter()" (onmouseleave)="onStarLeave()" (click)="onStarClicked()">
    <polygon stroke-width="0" points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" />
  </svg>



  



 